import { useState } from 'react';

import { TextsmsOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';

import AssessmentDialog from 'domains/content/components/Bee/AssessmentDialog';
import AssessmentPreviewDialog from 'domains/content/components/Bee/AssessmentPreviewDialog';
import ContentTaggingButtonWithDialog from 'domains/content/components/ContentTaggingButtonWithDialog';
import { ApplicationAccessType, CommunicationType, ContentTypeForComparison, SMS } from 'domains/content/types';
import PageHeader from 'domains/core/components/PageHeader';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText/ContentStatusText';

import SmsSendTestIconButton from '../SmsSendTest';

import AssessmentButton from './AssessmentButton';
import SaveAndExitButton from './SaveAndExitButton';

type SmsHeaderSectionProps = {
    applicationsAccess?: ApplicationAccessType[];
    communicationType?: CommunicationType;
    handleApplicationsAccess?: (event: any) => void;
    handleCommunicationType?: (event: any) => void;
    hasInvalidAutoResponses?: boolean;
    isAssessmentDialogVisible: boolean;
    isAssessmentEnabled: boolean;
    isLoading: boolean;
    onAssessmentSelected?: (
        assessmentId: string,
        assessmentName: string,
        isConsentRequired: boolean,
        tagToInsert: string
    ) => void;
    onSaveAndExit: (status?: ContentStatus) => void;
    setIsAssessmentDialogVisible: (isVisible: boolean) => void;
    setSmsData?: (data: Partial<SMS>) => void;
    smsData?: SMS;
};

const SmsHeaderSection = ({
    applicationsAccess,
    communicationType,
    handleApplicationsAccess,
    handleCommunicationType,
    hasInvalidAutoResponses,
    isAssessmentDialogVisible,
    isAssessmentEnabled,
    isLoading,
    onSaveAndExit,
    setIsAssessmentDialogVisible,
    smsData,
    onAssessmentSelected,
    setSmsData,
}: SmsHeaderSectionProps) => {
    const [isAssessmentPreviewDialogVisible, setIsAssessmentPreviewDialogVisible] = useState(false);
    return (
        <>
            <PageHeader
                icon={<TextsmsOutlined fontSize="inherit" />}
                header="text message"
                headerOthers={
                    <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            {isAssessmentEnabled && (
                                <AssessmentButton
                                    showAssessmentDialog={() => setIsAssessmentDialogVisible(true)}
                                    smsData={smsData}
                                />
                            )}
                            <SmsSendTestIconButton content={smsData?.content} />
                            <ContentTaggingButtonWithDialog
                                channel={ContentTypeForComparison.SMS}
                                handleApplicationsAccess={handleApplicationsAccess}
                                handleCommunicationType={handleCommunicationType}
                                selectedApplicationsAccess={applicationsAccess}
                                selectedCommunicationType={communicationType}
                            />
                        </Stack>
                        <SaveAndExitButton
                            hasInvalidAutoResponses={hasInvalidAutoResponses}
                            isLoading={isLoading}
                            onSaveAndExit={onSaveAndExit}
                            smsData={smsData}
                        />
                    </Stack>
                }
            />
            {isAssessmentEnabled && (
                <>
                    <AssessmentDialog
                        communicationType={communicationType}
                        content={smsData}
                        isDialogVisible={isAssessmentDialogVisible}
                        onAssessmentPreview={() => setIsAssessmentPreviewDialogVisible(true)}
                        setIsDialogVisible={setIsAssessmentDialogVisible}
                        onAssessmentTagInsert={onAssessmentSelected}
                        setContent={setSmsData}
                    />
                    <AssessmentPreviewDialog
                        isOpen={isAssessmentPreviewDialogVisible}
                        handleClose={() => setIsAssessmentPreviewDialogVisible(false)}
                    />
                </>
            )}
        </>
    );
};

export default SmsHeaderSection;
